import AssignList from "./assignListing.container";

export default AssignList;
